// src/data/blobPaths.ts

export const BLOB_PATHS = {
  cursos: [
    "M50,10 C80,5 95,30 90,55 C85,80 65,95 45,90 C25,85 5,70 10,45 C15,20 20,15 50,10Z",
    "M55,8 C85,10 95,35 88,60 C80,85 60,98 35,92 C10,86 3,65 8,40 C13,15 25,6 55,8Z",
    "M48,5 C75,8 92,28 93,58 C94,88 70,98 42,95 C14,92 2,72 5,45 C8,18 21,2 48,5Z",
  ],
  clubSocias: [
    "M50,12 C75,12 92,22 88,48 C84,74 72,88 48,92 C24,96 8,76 12,50 C16,24 25,12 50,12Z",
    "M46,8 C70,14 88,28 92,54 C96,80 68,90 44,88 C20,86 12,68 8,44 C4,20 22,2 46,8Z",
    "M52,15 C78,10 90,30 86,52 C82,74 62,86 38,90 C14,94 10,72 14,48 C18,24 26,20 52,15Z",
  ],
  equipos: [
    "M50,15 C72,5 95,18 92,44 C89,70 75,90 50,88 C25,86 8,72 12,46 C16,20 28,25 50,15Z",
    "M48,10 C76,14 88,24 86,50 C84,76 70,92 46,86 C22,80 14,64 10,38 C6,12 20,6 48,10Z",
    "M54,12 C70,16 92,10 90,36 C88,62 78,82 54,92 C30,102 12,80 16,54 C20,28 38,8 54,12Z",
  ],
  udalekuak: [
    "M50,8 C78,8 92,20 88,46 C84,72 68,92 44,88 C20,84 8,66 12,40 C16,14 22,8 50,8Z",
    "M52,12 C72,8 86,22 90,48 C94,74 74,86 52,90 C30,94 14,78 10,52 C6,26 32,16 52,12Z",
    "M46,10 C68,6 94,16 92,42 C90,68 66,88 42,86 C18,84 12,60 16,34 C20,8 24,14 46,10Z",
  ],
  entidades: [
    "M50,10 C76,12 90,26 86,52 C82,78 68,90 44,86 C20,82 10,64 14,38 C18,12 24,8 50,10Z",
    "M48,8 C72,6 88,22 92,48 C96,74 70,88 48,92 C26,96 12,74 8,48 C4,22 24,10 48,8Z",
    "M52,12 C78,16 92,24 88,50 C84,76 64,86 40,88 C16,90 8,68 12,42 C16,16 26,8 52,12Z",
  ]
}
